import Timeline from "components/BaseWidgets/Timeline";
import ActivityEmpty from "../ActivityEmpty";

function Activities({ data }) {
  return (
    <>
      {data.length ? (
        <div className="activity-card">
          {data.map((section, index) => (
            <div key={index} className="flex flex-col gap-6">
              <span className="font-title-normal">{section.title}</span>
              <Timeline data={section.data} />
            </div>
          ))}
        </div>
      ) : (
        <ActivityEmpty />
      )}
    </>
  );
}

export default Activities;
